import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { ExternalLearningContentBanner } from '../../features/learningContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LessonOverview = ({
  description,
  hubId
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [hubId && /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(ExternalLearningContentBanner, {
        hubId: hubId
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInformation.header"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    })]
  });
};
export default LessonOverview;